export default function registerEnquiryFormScreen(Alpine) {
    Alpine.data('enquiryFormPage', () => ({
        returnUrl: '',

        init() {
            const el = document.getElementById('enquiry-form-server-data');
            if (!el) {
                return;
            }
            const data = JSON.parse(el.textContent);
            this.returnUrl = data.myloginReturnUrl || '';
        },

        goBackToApplication() {
            if (this.returnUrl) {
                window.location.assign(this.returnUrl);
            }
        },
    }));

    Alpine.data('enquiryFormScreen', () => ({
        stage: '1-support-required',
        supportRequiredChoice: null,
        contactMethodChoice: null,
        supportRequiredOptions: [],
        contactMethodOptions: [],
        fileName: '',
        filesizeError: false,
        submitting: false,
        fileTooLarge: '',
        filePlaceholder: '',
        processing: '',
        submit: '',

        init() {
            const el = document.getElementById('enquiry-form-server-data');
            if (!el) {
                return;
            }
            const data = JSON.parse(el.textContent);
            this.supportRequiredOptions = data.supportRequiredOptions || [];
            this.contactMethodOptions = data.contactMethodOptions || [];
            this.fileTooLarge = data.fileTooLarge || '';
            this.filePlaceholder = data.filePlaceholder || '';
            this.processing = data.processing || '';
            this.submit = data.submit || '';
        },

        progressToContactMethod() {
            if (this.supportRequiredChoice === 'general_query') {
                this.stage = '2-contact-method';
            } else if (this.supportRequiredChoice === 'online_tutorial') {
                this.stage = '4-calendar-open';
                window.open('https://www.myfuturechoice.com/demo-request/', '_blank')?.focus();
            }
        },

        progressToEmailContact() {
            if (this.contactMethodChoice === 'email') {
                this.stage = '3-email-contact';
            } else if (this.contactMethodChoice === 'phone') {
                this.stage = '4-calendar-open';
                window.open('https://www.myfuturechoice.com/contact-us/', '_blank')?.focus();
            }
        },

        reopenAppointmentForm() {
            if (this.contactMethodChoice === 'phone') {
                window.open('https://www.myfuturechoice.com/contact-us/', '_blank')?.focus();
            } else {
                window.open('https://www.myfuturechoice.com/demo-request/', '_blank')?.focus();
            }
        },

        returnToPreviousStage() {
            if (this.supportRequiredChoice === 'online_tutorial') {
                this.stage = '1-support-required';
            } else {
                this.stage = '2-contact-method';
            }
        },

        updateFileText(event) {
            this.filesizeError = false;
            const { files } = event.target;
            if (!files || !files[0]) {
                this.fileName = '';
                return;
            }
            const fileSize = files[0].size / 1024 / 1024;
            if (fileSize > 4) {
                this.filesizeError = true;
            }
            this.fileName = files[0].name;
        },

        handleEnquirySubmit() {
            this.submitting = true;
        },
    }));
}
